import { DataGridTableProps } from '../types';
import { SidePanel } from '../../SidePanel/SidePanel';
import { PlayerPortalsIDCard } from '../../PlayerPortals';

import { DataGridTable } from '../DataGridTable';

import styles from '../DataGridTable.module.scss';

type DataGridSidePanelProps = {
  isPPproject: boolean;
  sidePanel: DataGridTableProps['sidePanel'];
  isPanelOpen: boolean;
  setIsPanelOpen: (isOpen: boolean) => void;
  selectedItem: any | null;
  setSelectedItem: (item: any | null) => void;
  filteredItems: any[];
};

export const DataGridSidePanel = ({
  isPPproject,
  sidePanel,
  isPanelOpen,
  setIsPanelOpen,
  selectedItem,
  setSelectedItem,
  filteredItems,
}: DataGridSidePanelProps) => {
  if (
    !isPPproject ||
    !sidePanel ||
    !isPanelOpen ||
    !selectedItem?.ppContactId
  ) {
    return null;
  }

  return (
    <SidePanel
      isPanelOpen={isPanelOpen}
      setIsPanelOpen={setIsPanelOpen}
      items={filteredItems}
      selectedItem={selectedItem}
      setSelectedItem={setSelectedItem}
    >
      <div className={styles.sidePanelContent}>
        <PlayerPortalsIDCard
          {...sidePanel.idCard}
          playerContactId={selectedItem?.ppContactId}
        />
        <DataGridTable
          key={selectedItem?.id}
          {...sidePanel.accreditedMembersTable}
          customContactId={selectedItem?.ppContactId}
        />
      </div>
    </SidePanel>
  );
};
